import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BillingTermToggle } from 'pricing-pages-ui-components/toggle/BillingTermToggle';
import { jsx as _jsx } from "react/jsx-runtime";
const HsocTermToggle = ({
  activeTerm,
  onTermChange
}) => {
  const isAnnual = activeTerm === 'ANNUAL';
  return /*#__PURE__*/_jsx(BillingTermToggle, {
    isAnnual: isAnnual,
    onToggle: () => onTermChange(isAnnual ? 'MONTHLY' : 'ANNUAL'),
    labelMonthly: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.termToggle.billedMonthly"
    }),
    labelAnnual: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.termToggle.billedAnnually"
    }),
    ariaLabel: isAnnual ? I18n.text('hsocPricingPage.termToggle.ariaLabelAnnual') : I18n.text('hsocPricingPage.termToggle.ariaLabelMonthly'),
    bestValueLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.termToggle.bestValue"
    }),
    "data-selenium-id": "hsoc-term-toggle"
  });
};
export default HsocTermToggle;